/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable no-trailing-spaces */
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import {AddReviewPage} from '../../app/models/add-review/add-review.page'
import { GlobalVariable } from '../global';
import { UserApiService } from '../services/user-api.service';
@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.page.html',
  styleUrls: ['./reviews.page.scss'],
})
export class ReviewsPage implements OnInit {
  businessDetail: any;
  averageRating: number;
  isDataLoaded=false;
reviews=[]
  Randomcolor: string;
  constructor(
    private modalController:ModalController,
    public globals:GlobalVariable,
    public server:UserApiService,
    
    ) {
      this.businessDetail=this.globals.businessData
      // this.averageRating=Number(this.businessDetail.average_rating)
    
     }

  ngOnInit() {
  
 
    }
    ionViewWillEnter(){
      this.getColors()
      this.getReviews();
    }
    getReviews(){
      this.server.getReviews().subscribe(data=>{
        this.isDataLoaded=true;
        console.log('reviewcheck',data)
        this.reviews=data.reviews;
      },err=>{
        console.log('reviewcheck',err)
        this.globals.presentToast('Network Error!')
      })
    }
    
  
  async addNewReview() {
   let login= localStorage.getItem('isLogin')
   if(login!='true'){
     this.globals.presentToast('Please login first.');
     return
   }

    const modal = await this.modalController.create({
      component: AddReviewPage,
      cssClass: 'addReviewModal',
    });
    modal.onDidDismiss().then(data=>{
      this.getReviews();
    })
    await modal.present();
   
  }
  getColors() {
    let symbols = '0123456789ABCDEF';

    let color = "#";
    for (var i = 0; i < 6; i++) {
      color = color + symbols[Math.floor(Math.random() * 16)]
    }
    this.Randomcolor = color
    console.log(this.Randomcolor)

  }
}
